import React, { useState } from 'react';
import { createLeaderAccount } from '../../api/adminApi';

const CreateLeader = () => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setResult(null);
    try {
      const res = await createLeaderAccount({ email, first_name: firstName, last_name: lastName });
      setResult(res);
      setEmail(''); setFirstName(''); setLastName('');
    } catch (err) {
      setError(err.message || 'Failed to create account');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-6 bg-white rounded-xl shadow-lg">
      <h2 className="text-3xl font-bold mb-4 text-indigo-700">Create Module Leader</h2>
      <p className="text-gray-600 mb-6">Create a new module leader account. A random password will be generated and shown once.</p>

      <form onSubmit={handleSubmit} className="space-y-4 max-w-md">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full p-2 border border-gray-300 rounded-lg" />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">First name</label>
          <input value={firstName} onChange={(e) => setFirstName(e.target.value)} className="w-full p-2 border border-gray-300 rounded-lg" />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Last name</label>
          <input value={lastName} onChange={(e) => setLastName(e.target.value)} className="w-full p-2 border border-gray-300 rounded-lg" />
        </div>

        <button type="submit" disabled={isSubmitting} className="bg-indigo-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-indigo-700">
          {isSubmitting ? 'Creating...' : 'Create Leader'}
        </button>
      </form>

      {error && <p className="mt-4 text-sm text-red-600">Error: {error}</p>}

      {result && (
        <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded-lg">
          <p className="font-semibold text-green-700">Leader account created:</p>
          <p className="text-sm">Email: <strong>{result.email}</strong></p>
          <p className="text-sm">Account ID: <strong>{result.account_id}</strong></p>
          <p className="mt-2 text-sm text-gray-800">Temporary password (show once):</p>
          <div className="mt-2 p-3 bg-white border rounded shadow-sm font-mono text-sm">{result.password}</div>
          <p className="mt-2 text-xs text-gray-600">Share this password with the user so they can sign in and reset it.</p>
        </div>
      )}
    </div>
  );
};

export default CreateLeader;
